"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./AlertTileComponent.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AlertTileComponent = function AlertTileComponent(props) {
  var alertClass = props.alertMessageType === "error" ? 'error-red' : props.alertMessageType === "wran" ? 'warning-orange' : "normal-info";
  var getAlertVariant = function getAlertVariant() {
    switch (props === null || props === void 0 ? void 0 : props.variant) {
      case "tile":
        return /*#__PURE__*/_react.default.createElement("div", {
          "data-testid": "alertTileWarpper-info",
          className: "d-flex flex-column tile-alert-wrapper ".concat(props.fullWidth ? "w-full" : "w-max-520", " ").concat(props.noBoarder ? "" : "wrapper-border", " ").concat(props.isRead ? "alertRead" : ""),
          onClick: props.onClick ? props.onClick : function () {},
          onBlur: props.onBlur ? props.onBlur : function () {},
          style: _objectSpread({}, props.wrapperStyle)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "tile-alert-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex tile-icon-container-left justify-content-center"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column",
          style: {
            marginRight: "auto",
            color: "#333333"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "tile-alert-text-style"
        }, props.alertheading)), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column justify-content-center"
        }, /*#__PURE__*/_react.default.createElement("div", null, props.alertImageRight && /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertImageRight,
          className: "tile-alert-image"
        })))), /*#__PURE__*/_react.default.createElement("div", {
          className: "tile-alert-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex tile-icon-container-left justify-content-center",
          style: {
            width: "10%"
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex justify-content-center"
        }, props.alertImageLeft && /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertImageLeft,
          className: "alert-image-1"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column ".concat(alertClass),
          style: {
            marginRight: "auto",
            width: "80%"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "tile-alert-text-style",
          style: {
            fontSize: "16px",
            lineHeight: "22px"
          }
        }, props.alertText)), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "10%"
          }
        }, /*#__PURE__*/_react.default.createElement("div", null))), /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex tile-icon-container-left justify-content-center",
          style: {
            width: "10%"
          }
        }, /*#__PURE__*/_react.default.createElement("div", null)), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column",
          style: {
            marginRight: "auto",
            width: "80%"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: "13px",
            lineHeight: "20px"
          }
        }, props.Description)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "10%"
          }
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex tile-icon-container-left justify-content-center",
          style: {
            width: "10%"
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "30px"
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column",
          style: {
            marginRight: "auto"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: "10px",
            lineHeight: "15px"
          }
        }, props.date)), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "10%"
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "30px"
          }
        }))), (props === null || props === void 0 ? void 0 : props.optionBtnTitle) && /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex tile-icon-container-left justify-content-center"
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "30px"
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column justify-content-right",
          style: {
            marginLeft: "auto"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontFamily: 'Poppins',
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "13px",
            lineHeight: "20px",
            color: "#006E96"
          },
          onClick: props !== null && props !== void 0 && props.optionBtnClick ? props.optionBtnClick : function () {}
        }, props.optionBtnTitle)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "30px"
          }
        }))));
      case "Incomplete_System":
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "ok-alert-tile-wrapper-Partial"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertOkImage,
          className: "alert-image-Partial",
          alt: ""
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-text-Partial"
        }, /*#__PURE__*/_react.default.createElement("span", null, props.alertOkText))));
      default:
        return props.isAlert ? /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-wrapper",
          onClick: props.onClickAlert
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertImage,
          className: "alert-image-1",
          alt: ""
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-text"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: props.alertTextStyle
          }
        }, props.alertText))), /*#__PURE__*/_react.default.createElement("div", null, props.alertImageRight && /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertImageRight,
          className: "alert-image-style"
        }))) : /*#__PURE__*/_react.default.createElement("div", {
          className: "ok-alert-tile-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-tile-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: props.alertOkImage,
          className: "alert-image-1"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "alert-text-Ok"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: 'green'
          }
        }, props.alertOkText))));
    }
  };
  return getAlertVariant();
};
var _default = AlertTileComponent;
exports.default = _default;